import { useState } from 'react';
import QuizQuestion from './QuizQuestion';
import { getQuestionType } from '../api/common';
import QuizStepDisplay from './QuizStepDisplay';

const QuizStep = props => {
    const { step, goNext, getAnswer } = props;
    const [questionIndex, setQuestionIndex] = useState(0);
    const [answers, setAnswers] = useState([]);

    function goNextQuestion(answer) {
        const question = step.questions[questionIndex];
        answers.push({ questionIndex, order: question.order, answer, type: getQuestionType(question), dimension: question.dimension, question, stepTitle: step.title });
        setAnswers([...answers]);

        if (step.questions.length - 1 === questionIndex) {
            goNext(answers);
            setAnswers([]);
            setQuestionIndex(0);
        } else {
            setQuestionIndex(questionIndex + 1);
        }
    }

    const question = step && step.questions[questionIndex];

    return !step ? 'step loading' : (
        <div>
            <QuizStepDisplay step={step} question={question} />
            <section id="content">
                <div className="content-wrap">
                    <div className="container clearfix">
                        <div className="promo p-4">
                            <div className="row align-items-center">
                                <div className="col-12 col-lg">
                                    <h1><span>{step.title}</span></h1>
                                    <p>{answers.length+1} / {step.questions.filter(q=>!q.pass).length}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <QuizQuestion getAnswer={getAnswer} question={question} goNext={goNextQuestion} />
        </div>
    )
}
export default QuizStep;